import { Component } from '@angular/core';
import { assets } from '../../core/constants/assets.const';
import {MatTooltipModule} from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';


@Component({
  selector: 'fgsn-ecommerce-website-footer',
  standalone: true,
  imports: [MatTooltipModule, RouterModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  assetsConst = assets;
  currentYear: number;
  constructor() {
    this.currentYear = new Date().getFullYear();
  }
  needHelp = [
    {
      mainTitle:'NEED HELP ?'
    },
    {
      title:'Contact Us',
      path:'/support/contact-us'
    },
    {
      title:'Faqs',
      path:'/support/faq'
    }
  ];
  ourCompany = [
    {  
      mainTitle:'Our Company'
    },
    {
      title:'About Us',
      path:'/support/about-us'
    },
    {
      title:'Terms & Conditions',
      path:'/support/term-and-condition'
    },
    {
      title:'Privacy Policy',
      path:'/support/privacy-policy'
    },
    {
      title:'Shipping Policy',
      path:'/support/shipping'
    },
    {
      title:'Cancellation Policy',
      path:'/support/cancellation'
    }
  ];
}
